import Skeleton from "@material-ui/lab/Skeleton";
import React, { useEffect } from "react";
import BlogData from "../Blog/BlogData/BlogData";
import './welcome.css';
const Welcome = (props: any) => {
    const { 
        contents, 
        loading, 
        setCurrentBlogName, 
        navigateToPost, 
        setWhichPageChild 
    } = props;
    useEffect(() => {
        window.onload = setWhichPageChild('welcome')
    }, [])
    return (
        <div className={'welcome-container'}>   
            <div className={'welcome-wrapper'}>
                <div className="welcome-header">
                    <h1 id={'welcome-h1'}>
                        The Reactive Solutions Full Stack Blog <br />
                    <small>Articles About Full Stack Applications.</small>
                    </h1>
                    <hr className={'hr-h1'} />
                </div>
                <div className={'welcome-main'}>
                     {loading 
                     ? (
                        <div style={{backgroundColor: 'white'}}>
                            <div>
                                <Skeleton style={{maxWidth: 640, width: 'auto', height: 300, marginTop: -20 }}/>
                            </div>
                            <div style={{marginTop: 10}}>
                                <Skeleton width={640} />
                            </div>
                            <div style={{marginTop: 10}}>
                                <Skeleton width={640} />
                                <Skeleton width={640} />
                                <Skeleton width={640} />
                                <Skeleton width={640} />
                                <Skeleton width={640} />
                                <Skeleton width={640} />
                                <Skeleton width={640} />
                                <Skeleton width={640} />
                            </div>
                        </div>
                        ) 
                     : (<BlogData 
                            setCurrentBlogName={setCurrentBlogName}         
                            contents={contents} 
                            navigateToPost={navigateToPost}
                            />)}                                           
                </div>
            </div>
        </div>
    )
}
export default Welcome;